module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.3.4-105.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.3.4.md
// module id = 520
// module chunks = 305